export default __webpack_public_path__ + "static/char-v-36-37a0eff7f9e4e1525cb148ce80eefa89.png";